import { useEffect, useRef, useState } from "react";

const Toast = ({ getMsg }: any) => {
  const msg = getMsg();
  const [toastOption, setToastOption] = useState<any>({ active: false });
  const promptInputRef = useRef<any>();
  const toastRef = useRef<any>();
  let win: any = window;

  win.alert = (msg: string, callback: Function, closeCallBack: Function) => {

    const option = { ...toastOption };

    option['active'] = true;
    option['msg'] = msg;
    option['type'] = 'alert';
    option['callBack'] = callback;
    option['closeCallBack'] = closeCallBack;

    setToastOption(option);
  }

  win.confirm = (msg: string, callback: Function) => {
    const option = { ...toastOption };

    option['active'] = true;
    option['msg'] = msg;
    option['type'] = 'confirm';
    option['callBack'] = callback;

    setToastOption(option);
  }

  win.prompt = (msg: string, placeholder: string, callback: Function) => {
    const option = { ...toastOption };

    if (promptInputRef['current']) {
      promptInputRef['current']['value'] = '';
    }

    option['active'] = true;
    option['msg'] = msg;
    option['placeholder'] = placeholder;
    option['type'] = 'prompt';
    option['callBack'] = callback;

    setToastOption(option);
  }
  const positiveClick = () => {
    setToastOption({ ...toastOption, active: false });
    if (toastOption['callBack']) {

      if (toastOption['type'] === 'prompt') {
        toastOption['callBack'](promptInputRef['current']['value']);
      } else {
        toastOption['callBack']();
      }
    }
  }

  const closeClick = () => {
    setToastOption({ ...toastOption, active: false });
    if (toastOption['closeCallBack']) {
      toastOption['closeCallBack']();
    }
  }

  useEffect(() => {
    if (toastOption['active']) {
      toastRef['current'].focus();
    }
  }, [toastOption])

  return (
    <>
      <div className={"toast toast-mobile fade " + (toastOption['active'] ? "show" : "displayNone")} onKeyUp={(e) => { if (e.key === 'Escape') { setToastOption({ ...toastOption, active: false }) } }} ref={toastRef} tabIndex={0}>
        <div className="toast-header">
          <strong className="toast-tit mr-auto">{toastOption['type'] === 'prompt' ? toastOption['msg'] : msg['notice']}</strong>
          <button type="button" className="btn btn-transparent close" onClick={() => { closeClick() }}></button>
        </div>
        <div className="toast-body">
          {toastOption['type'] === 'prompt' ?
            <input type="text w100" placeholder={toastOption['placeholder']} ref={promptInputRef} style={{ width: '100%' }} />
            :
            <p className="text-center" dangerouslySetInnerHTML={{ __html: toastOption['msg'] }} />
          }
        </div>
        <div className="toast-foot btn-group">
          <button type="button" className="btn btn-popup positive" onClick={positiveClick}>{msg['confirm']}</button>
          {toastOption['type'] !== 'alert' && <button type="button" className="btn btn-popup negative" onClick={() => { setToastOption({ ...toastOption, active: false }) }}>{msg['close']}</button>}
        </div>
      </div>

      <div className={"toast-backdrop toast-backdrop-3 fade " + (toastOption['active'] ? "show" : "displayNone")} ></div>
    </>
  );
}

export default Toast;